<template>
    <div class="top-banner">
        <!--<div class="branch">{{brandName}}-{{storeName}}</div>-->

        <div v-if="false" class="rate-block">
            <el-rate
                    v-model="value"
                    disabled
                    show-score
                    text-color="#fff"
                    show-text
                    score-template="{value}">
            </el-rate>
            <div class="rate-total">
                (400)
            </div>
        </div>

        <el-image :src="storeImage" fit="cover" v-if="storeImage!==''"/>
        <el-image :src="require('@/assets/images/default_banner.svg')" fit="cover" v-else/>

    </div>
</template>

<script>

    export default {
        name: "Banner",
        props:{
            /*brandName: { type:String, default:'' },
            storeName: { type:String, default:'' },*/
            storeImage: { type:String, default:'' },
        },
        data() {
            return {
                value: 3.7,
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {

        }
    }
</script>

